<template>
    <div class="default-layout">
        <div v-if="!isMobile" class="header-background"/>
        <div v-if="isMobile && !showNav" class="nonav-header"/>
        <DefaultHeader v-if="showNav">
            <div class="default-container top">
                <DefaultNavigationBar></DefaultNavigationBar>
            </div>
        </DefaultHeader>
        <div class="default-container">
            <a v-if="(showBackButton || previousView) && !isMobile"
               @click="goBack"
               class="back-button">
                {{ $t("general.back") }}
            </a>
            <BubbleTabs v-if="$route.meta.bubbleTabs" :tabs="$route.meta.bubbleTabs" />
            <div class="content-container">
                <router-view></router-view>
            </div>
        </div>
        <div class="default-footer">
            <DefaultFooter v-if="!isMobile && showFooter" class="default-container"/>
        </div>
    </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator";
import DefaultNavigationBar from "../partials/DefaultNavigationBar.vue";
import DefaultFooter from "../partials/DefaultFooter.vue";
import DefaultHeader from "@/components/partials/DefaultHeader.vue";
import TDSButton from "@/components/common/TDSButton.vue";
import BubbleTabs from "@/components/partials/Navigation/BubbleTabs.vue";

@Component({
    components: {
        BubbleTabs,
        TDSButton,
        DefaultHeader,
        DefaultFooter,
        DefaultNavigationBar
    }
})
export default class DefaultLayout extends Vue {
    @Prop({type: Boolean, default: true}) showNav!: boolean;
    @Prop({type: Boolean, default: true}) showFooter!: boolean;
    @Prop({type: Boolean, default: false}) showBackButton!: boolean;

    get previousView(): string {
        return this.$store.state.previousView;
    }

    get isMobile(): boolean {
        return this.$store.state.isMobile;
    }

    private goBack() {
        if (this.previousView) {
            this.$router.push(this.previousView);
        } else {
            this.$router.go(-1);
        }
    }
}
</script>

<style lang="scss" scoped>

@keyframes page-fade-in {
    0% {
        transform: translateY(-15px);
    }
    100% {
        transform: translateY(0);
    }
}

.default-layout {
    position: relative;
    min-height: 100vh;

    .header-background {
        position: absolute;
        width: 100%;
        height: 208px;
        background-color: rgb(12, 14, 17);
        background-image: $gradient;
        transition: height ease-in-out 0.3s;
    }

    .nonav-header {
        height: 64px;
        width: 100vw;
        background: $gradient;
        position: absolute;
    }

    .default-container {
        max-width: $breakPoint;
        margin: 0 auto;
        position: relative;

        &.top {
            z-index: 999;
        }

        .back-button {
            @include backButton($imgPath: "../../");
            margin-top: 20px;
        }

        .content-container > * {
            animation: page-fade-in;
            animation-duration: 0.3s;
            animation-iteration-count: 1;
            animation-timing-function: ease-in-out;
            min-height: 100vh;

            //  This avoids that the margin from a child is set to the parents margin:
            //  https://stackoverflow.com/questions/13573653/css-margin-terror-margin-adds-space-outside-parent-element
            overflow: auto;
            padding-top: $defaultHeaderHeight;

            @media only screen and (min-width: $breakPoint) {
                padding-top: 0;
                padding-bottom: 60px;
                min-height: calc(100vh - #{$defaultHeaderHeightDesktop} - #{$defaultFooterHeight});
            }
        }
    }

    .default-footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        z-index: 4;
    }
}

</style>
